import { MapsTemp } from './map-functions-temp';
import { StackPlazaOptions } from './stack-platza';
import { ROAD } from './constants';
import { MiamiBeach } from './miami-beach';

export const DegenRaceway: { id: MapsTemp } & Record<string, any> = {
  // TODO(andrei): Temp because I cannot serialize the functions
  id: 'degenRaceway',
  spriteSuffix: '_stacks.png',
  backgroundSuffix: '_DegenRaceway.png',
  COLORS: {
    SKY: '#6ab89d',
    TREE: '#4a4edf',
    FOG: '#2f4a2a',
    LIGHT: { road: '#828282', grass: '#619157', rumble: '#c54a4a', lane: '#ffffff' },
    DARK: { road: '#6f6f6f', grass: '#35542f', rumble: '#ffffff' },
    START: { road: '#a0a6a2', grass: '#a0a6a2', rumble: '#a0a6a2' },
    FINISH: { road: 'black', grass: 'black', rumble: 'black' },
  },
  BACKGROUND: {
    HILLS: { x: 5, y: 5, w: 1285, h: 480 },
    SKY: { x: 5, y: 495, w: 1285, h: 480 },
    TREES: { x: 5, y: 985, w: 1285, h: 480 },
  },
  SPRITES: {
    PALM_TREE: { x: 1, y: 1, w: 217, h: 521 },
    BILLBOARD08: { x: 651, y: 924, w: 524, h: 350 },
    TREE1: { x: 930, y: 0, w: 407, h: 397 },
    DEAD_TREE1: { x: 0, y: 522, w: 213, h: 484 },
    BILLBOARD09: { x: 685, y: 1291, w: 467, h: 384 },
    BOULDER3: { x: 483, y: 43, w: 456, h: 305 },
    COLUMN: { x: 1357, y: 0, w: 293, h: 404 },
    BILLBOARD01: { x: 636, y: 598, w: 567, h: 321 },
    BILLBOARD06: { x: 1228, y: 958, w: 523, h: 343 },
    BILLBOARD05: { x: 1221, y: 600, w: 538, h: 345 },
    BILLBOARD07: { x: 1213, y: 1307, w: 562, h: 350 },
    BOULDER2: { x: 300, y: 400, w: 360, h: 170 },
    TREE2: { x: 1670, y: 0, w: 328, h: 336 },
    BILLBOARD04: { x: 1635, y: 410, w: 361, h: 169 },
    DEAD_TREE2: { x: 235, y: 0, w: 250, h: 360 },
    BOULDER1: { x: 220, y: 630, w: 236, h: 347 },
    BUSH1: { x: 10, y: 1025, w: 273, h: 168 },
    CACTUS: { x: 780, y: 410, w: 330, h: 165 },
    BUSH2: { x: 1126, y: 415, w: 245, h: 160 },
    STUMP: { x: 1384, y: 410, w: 250, h: 175 },
    SEMI: { x: 1777, y: 670, w: 215, h: 254 },
    TRUCK: { x: 1776, y: 941, w: 178, h: 139 },
    CAR03: { x: 1808, y: 1146, w: 158, h: 96 },
    CAR02: { x: 1808, y: 1260, w: 141, h: 104 },
    CAR04: { x: 1808, y: 1381, w: 142, h: 102 },
    CAR01: { x: 1804, y: 1517, w: 139, h: 100 },
    SCALE: 0.3 * (1 / 84), // the reference sprite width should be 1/3rd the (half-)roadWidth
  },
  CAR_SCALE: 1 / 4,
  BASIC_CARS_SCALE: 1 / 1.7,
  totalCars: 195,
  nextGame: MiamiBeach,
  sCurves: [
    [ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.CURVE.MEDIUM, -ROAD.HILL.LOW],
    [ROAD.LENGTH.SHORT, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.SHORT, -ROAD.CURVE.HARD, -ROAD.HILL.MEDIUM],
    [ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.LENGTH.MEDIUM, ROAD.CURVE.HARD, ROAD.HILL.MEDIUM],
    [ROAD.LENGTH.SHORT, ROAD.LENGTH.LONG, ROAD.LENGTH.SHORT, -ROAD.CURVE.MEDIUM, -1 * ROAD.HILL.HIGH],
    [ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.CURVE.EASY, ROAD.HILL.HIGH],
    [ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.CURVE.EASY, ROAD.HILL.LOW],
  ],
};
